import { Befehl } from '../models'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 2 has empty fields.
 *
 * Befehl 2 has no special business rules beyond checking if fields are empty,
 * so it uses the generic empty field check.
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl2EmptyFields(befehl: Befehl): boolean {
  return hasBefehlGenericEmptyFields(befehl)
}
